import { css } from 'styled-components';
import { InputMixin } from './InputMixin';

/** @class TextareaMixin */
/** @method */
export var TextareaMixin = function TextareaMixin(props) {
  var resize = props.resize;
  return css(["", " resize:", ";height:auto;vertical-align:top;"], InputMixin(props), resize);
};